import { Injectable } from '@angular/core';

/** A service for showing various types of notifications via Material style notifications, such as snackbars and dialogs. */
@Injectable({
    providedIn: 'root'
})
export class NotofierUtilitiesService {

    mergePanelClass (panelClass: string | Array<string>, newClasses: Array<string>): string | Array<string> {
        if (newClasses.length < 1) {
            return panelClass;
        }
        if (!panelClass) {
            return newClasses;
        }
        // Ensure panelClass is an array for the destructuring
        if (panelClass.constructor !== Array) {
            panelClass = [ panelClass as string ];
        }
        return [ ...panelClass, newClasses ] as Array<string>;
    }

}
